<mat-icon
  aria-hidden="false"
  class="sidebar-with-badge"
  matBadgeSize="small"
  [ngClass]="{ expanded: expanded }"
  [matBadge]="badge$ | async"
  [matBadgeHidden]="(badge$ | async) === 0"
  [matBadgeColor]="badgeColor"
>
  {{ icon }}
</mat-icon>

@if (expanded) {
  <div class="flex flex-1 justify-between">
    <div class="flex flex-row items-start justify-start gap-2">
      <h4>{{ label }}</h4>
      <small *ngIf="isDev" matTooltip="This feature is dev status">Dev</small>
      <small *ngIf="isAlpha" matTooltip="This feature is alpha status">
        Alpha
      </small>
    </div>

    <div class="flex items-center gap-2">
      <span
        class="trailing-badge flex"
        matBadgeSize="medium"
        [matBadge]="badge$ | async"
        [matBadgeHidden]="(badge$ | async) === 0"
        [matBadgeColor]="badgeColor"
      >
      </span>

      <ng-content />
    </div>
  </div>
}
